import React from "react";
import BaseBlockContent from "@sanity/block-content-to-react";
// import Img from "gatsby-image";
// import { useStaticQuery, graphql } from "gatsby";
import { BlockContentStyle } from "./elements";
// import { getFluidGatsbyImage } from "gatsby-source-sanity";
// import { Config } from "./../../../config";

// TODO: fix this so it works with current Sanity image model

const BlockContent = ({ blocks }) => {
  // const codes = useStaticQuery(graphql`
  //   {
  //     allSanityImageAsset {
  //       nodes {
  //         url
  //         localFile {
  //           publicURL
  //           childImageSharp {
  //             fluid(maxWidth: 864) {
  //               ...GatsbyImageSharpFluid
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // `);
  // const imageData = codes.allSanityImageAsset.nodes;
  const serializers = {
    marks: {
      em: (props) => <em>{props.children}</em>,
      link: ({ children, mark }) => (
        <a href={mark.href} target="_blank" rel="noreferrer">
          {children}
        </a>
      ),
      // thought: (props) => {
      //   const thisThought = codes.allSanityThought.nodes.filter(
      //     (x) => x._id === props.mark._ref
      //   )[0].slug.current;
      //   return <Link to={`/thoughts/${thisThought}`}>{props.children}</Link>;
      // },
    },
    types: {
      // image: ({ node }) => {
      // TODO: Turned off because this code no longer works?
      //   const imageId = node.asset._ref;
      //   const middle = imageId.split("-")[1];
      //   // console.log(imageId, middle);
      //   // TODO: I think this could be done in a smarter way?
      //   let fluidProps = getFluidGatsbyImage(
      //     imageId,
      //     { maxWidth: 864 },
      //     Config.sanity
      //   );

      //   let theUrls = imageData.map((x) => x.url);
      //   for (let i = 0; i < theUrls.length; i++) {
      //     if (theUrls[i].indexOf(middle) > -1) {
      //       if (
      //         imageData[i].localFile &&
      //         imageData[i].localFile.childImageSharp
      //       ) {
      //         fluidProps = imageData[i].localFile.childImageSharp.fluid;
      //         return <Img fluid={fluidProps} />;
      //       } else {
      //         // this happens for the weird GIF which won't go through ImageSharp
      //         // console.log(imageData[i]);
      //         return (
      //           <img
      //             src={
      //               imageData[i].localFile
      //                 ? imageData[i].localFile.publicURL
      //                 : imageData[i].url
      //             }
      //             style={{ width: "100%", height: "auto" }}
      //           />
      //         );
      //       }
      //     }
      //   }
      // },
      block({ children, node }) {
        switch (node.style) {
          case "h1":
            return <h1>{children}</h1>;
          case "h2":
            return <h2>{children}</h2>;
          case "h3":
            return <h3>{children}</h3>;
          case "hr":
            return <hr />;
          case "h4":
            return <h4>{children}</h4>;
          case "blockquote":
            return <blockquote>{children}</blockquote>;
          default:
            return <p>{children}</p>;
        }
      },
    },
  };
  return blocks && blocks.length ? (
    <BlockContentStyle>
      <BaseBlockContent blocks={blocks} serializers={serializers} />
    </BlockContentStyle>
  ) : null;
};

export default BlockContent;
